export const messages = {
  en: {
    printCommonReportTable: {
      print: 'Print',
      cancel: 'Cancel',
      componentName: 'Report Name',
      tableHeader: 'Table Header',
      footer: 'Footer Information'
    }
  },
  zh: {
    printCommonReportTable: {
      print: '打印',
      cancel: '取消',
      componentName: '报表名称',
      tableHeader: '表头',
footer: '頁腳信息'
    }
  },
  'zh-TW': {
    printCommonReportTable: {
      print: '列印',
      cancel: '取消',
      componentName: '報表名稱',
      tableHeader: '表頭',
      footer: '頁腳信息'
    }
  }
}